import React from "react";
import { Mail, Facebook, Instagram, Sparkles } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="relative z-20 border-t border-[#D4AF37]/30 bg-[#0B1437]/90 backdrop-blur-md py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
        
        {/* Brand & Copyright */}
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#F1D26B]/20 via-[#D4AF37]/10 to-transparent border border-[#D4AF37]/50 flex items-center justify-center text-[#F1D26B] shadow-[0_0_12px_rgba(212,175,55,0.2)]">
            <Sparkles className="w-4 h-4" />
          </div>
          <div>
            <span className="font-heading text-base text-[#EDE7D8] font-semibold tracking-wide">
              Il Genio in Vacanza
            </span>
            <p className="text-xs text-[#EDE7D8]/50">© 2026</p>
          </div>
        </div>

        {/* Social con i Colori Originali di Brand */}
        <div className="flex items-center gap-4">
          {/* Email */}
          <a
            href="mailto:info@genioinvacanza.it"
            className="flex items-center gap-2.5 px-4 py-2 rounded-full bg-gradient-to-r from-[#D4AF37]/15 to-[#D4AF37]/5 border border-[#D4AF37]/40 text-xs font-medium text-[#EDE7D8] hover:text-[#FFF3C0] hover:border-[#D4AF37] transition-all duration-300"
          >
            <Mail className="w-4 h-4 text-[#F1D26B]" />
            <span>info@genioinvacanza.it</span>
          </a>

          {/* Facebook Original Brand */}
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-[#1877F2] hover:bg-[#166FE5] flex items-center justify-center text-white shadow-md hover:scale-105 transition-all duration-300"
            aria-label="Facebook"
          >
            <Facebook className="w-4 h-4 fill-current" />
          </a>

          {/* Instagram Original Brand */}
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] flex items-center justify-center text-white shadow-md hover:scale-105 hover:shadow-[0_0_15px_rgba(220,39,67,0.4)] transition-all duration-300"
            aria-label="Instagram"
          >
            <Instagram className="w-4 h-4" />
          </a>
        </div>

      </div>
    </footer>
  );
}
